import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { reduxForm, destroy, initialize, reset } from 'redux-form'
import { post, put, destroy as handleDelete } from '../modules/daily_product'
import { copy } from '../modules/pricelist'

import moment from 'helpers/moment'

import component from 'components/DailyProducts'

const formName = 'new-daily_product'
const fields = [
  'date', 'product_id', 'scientific_name', 'details', 'enabled',
  'tasting_notes', 'sourcing_location', 'sourcing_method', 'fishing_vessel',
  'prices[].price', 'prices[].uom_id', 'prices[].option_id'
]

const mapActionCreators = {
  copy,
  handleDelete, // NOTE: this cannot be named destroy as reduxForm uses that..
  put,
  post
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch,
  onSubmit: (data) => {
    let initialValues = mapStateToProps({}, ownProps).initialValues

    dispatch(post(data))
    dispatch(reset(formName))
    dispatch(destroy(formName))
    dispatch(initialize(formName, initialValues, fields))
  }
})

const mapStateToProps = (state, ownProps) => {
  let obj = {
    daily_product: state.daily_product,
    pricelist: state.pricelist,
    products: state.products,
    options: state.options,
    uoms: state.uoms,
    date: ownProps.params.date || 'today',
    initialValues: {
      enabled: true,
      date: ownProps.params.date || 'today',
      prices: []
    },
    isLoggedIn: state.auth && state.auth.isLoggedIn,
    isAdmin: state.auth && state.auth.isAdmin
  }

  if (ownProps.location.query.date) {
    obj.date = ownProps.location.query.date
    obj.initialValues.date = moment(ownProps.location.query.date).format('YYYY-MM-DD')
  } else if (ownProps.params.date) {
    obj.date = ownProps.params.date
    obj.initialValues.date = moment(ownProps.params.date).format('YYYY-MM-DD')
  }

  // set the initial product from location query (eg. daily_products/new/?produt_id=42)
  if (ownProps.location.query.product_id) {
    let productId = parseInt(ownProps.location.query.product_id, 10)
    let pricelistProduct = productId && state.pricelist && typeof state.pricelist.find === 'function' &&
      state.pricelist.find(o => o.product_id === productId)

    if (pricelistProduct) {
      ['product_id', 'fishing_vessel', 'sourcing_method', 'sourcing_location', 'scientific_name', 'details', 'tasting_notes']
        .forEach(field => {
          if (obj.initialValues[field] === undefined && pricelistProduct[field]) {
            obj.initialValues[field] = pricelistProduct[field]
          }
        })

      if (pricelistProduct.prices && typeof pricelistProduct.prices.filter === 'function') {
        pricelistProduct.prices.filter(price => price && price.price) // price.price is a value
          .map(price => obj.initialValues.prices.push(price))
      }
    }
  }

  obj.initialValues.prices = obj.initialValues.prices.filter(o => o && o.price)
  obj.initialValues.prices.push({ price: undefined, uom_id: undefined, option_id: undefined })

  return obj
}

const form = reduxForm({
  form: formName,
  fields,
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.date) errors.date = 'Please enter a date.'
    if (!state.product_id) errors.product_id = 'Please select a product.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/DailyProducts/containers/DailyProductsContainer.js